import { LINE_STATUS_OPTIONS } from './filter-options';

/**
 * Line status → display label, derived from `LINE_STATUS_OPTIONS` so the
 * filters and the tables can no longer diverge (they used to: « Annulé »
 * vs « Annulée », plus a typoed « Parametrage en progression »).
 * `terminated` is displayed but deliberately not filterable.
 */
export const statusMapping: Record<string, string> = {
  ...Object.fromEntries(
    LINE_STATUS_OPTIONS.map((option) => [option.value, option.label])
  ),
  terminated: 'Résiliée',
};
